import { Box, IconButton, useMediaQuery } from '@mui/material';

export function EscolaLegislativoBanner02() {
  const logo = '/images/escolalegislativo/banner_rolezinho.png';
  return (
    <Box
      sx={{
        mt: 1,
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          height: 'auto',
          maxHeight: {
            xs: '90px', // celulares
            sm: '100px', // tablets
            md: '250px', // desktops
            lg: '350px' // telas maiores
          }
        }}
      >
        <IconButton
          onClick={() => (window.location.href = '/escola-legislativo/home')}
          title="Início"
          sx={{            
            width: '100%',
            height: '100%'
          }}
        >
          <Box
            component="img"
            src={logo}
            alt={'logo'}
            sx={{
              width: '100%', // ocupa toda largura
              height: '100%', // ocupa toda altura
              objectFit: 'contain' // cobre o Box sem distorcer
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
}
